const gtmId = 'AW-377109918';
export const tagManagerArgs = { gtmId };